import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=d178850c&scoped=true"
import script from "./PartnersList.vue?vue&type=script&lang=js"
export * from "./PartnersList.vue?vue&type=script&lang=js"
import style0 from "./PartnersList.vue?vue&type=style&index=0&id=d178850c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d178850c",
  null
  
)

export default component.exports